module.exports = __webpack_public_path__ + "img/veri2.02a6c986.jpg";